
export const ROUTER_INFO_SELL_BONUS = {
  routes: ["/", "/logs", "/vehiclesDashboard/vehicleDetails/:id?","/sales/vehiclesDashboardvehicleDetails/:id?", "*"],
};

export const VEHICLE_MAIN_INFO_SELL_BONUS= {
  sellBonus: true,
};
